import { render, staticRenderFns } from "./TimelineContestantInteraction.vue?vue&type=template&id=0561cc99&scoped=true"
import script from "./TimelineContestantInteraction.vue?vue&type=script&lang=ts"
export * from "./TimelineContestantInteraction.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0561cc99",
  null
  
)

export default component.exports